// import React, { useState, useEffect } from "react";
// import { FaDollarSign, FaCheck, FaCheckCircle } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { Link as ScrollLink } from "react-scroll";
// import { motion, AnimatePresence } from "framer-motion";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useDispatch, useSelector } from "react-redux";
// import { API_URL } from "../../apiConfig";
// import HoaChoosePlan from "../HoaChoosePlan/HoaChoosePlan";
// import { RxCross1 } from "react-icons/rx";
// import axios from "axios";

// const HoaPlan = () => {
//     const [isMonthly, setIsMonthly] = useState(true); // Default to monthly
//     const [showModal, setShowModal] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [visibleSliderIndex, setVisibleSliderIndex] = useState(0);
//     const [planRanges, setPlanRanges] = useState([]);
//     const [planTypes, setPlanTypes] = useState([]);
//     const [planPeriods, setPlanPeriods] = useState([]);
//     const [prices, setPrices] = useState([]);
//     const [planDetails, setPlanDetails] = useState({});
//     const [planRangeId, setPlanRangeId] = useState(30);
//     const [planPeriodId, setPlanPeriodId] = useState(25);
//     const [planId, setPlanId] = useState(0);
//     const [data, setData] = useState([]);
//     const [isModalVisible, setIsModalVisible] = useState(false);
//     const [planIds, setPlanIds] = useState([]);
//     const dispatch = useDispatch();

//     const slickSettings = {
//         dots: false,
//         infinite: false,
//         speed: 500,
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         variableWidth: false,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     infinite: false,
//                 },
//             },
//             {
//                 breakpoint: 800,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     infinite: false,
//                 },
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     infinite: false,
//                 },
//             },
//         ],
//     };

//     // Animation variants
//     const containerVariants = {
//         hidden: { opacity: 0, y: 50 },
//         visible: {
//             opacity: 1,
//             y: 0,
//             transition: {
//                 duration: 0.6,
//                 staggerChildren: 0.1
//             }
//         }
//     };

//     const itemVariants = {
//         hidden: { opacity: 0, y: 20 },
//         visible: {
//             opacity: 1,
//             y: 0,
//             transition: { duration: 0.4 }
//         }
//     };

//     const cardVariants = {
//         hidden: { opacity: 0, scale: 0.9, y: 50 },
//         visible: {
//             opacity: 1,
//             scale: 1,
//             y: 0,
//             transition: {
//                 duration: 0.5,
//                 ease: "easeOut"
//             }
//         },
//         hover: {
//             y: -8,
//             scale: 1.02,
//             transition: {
//                 duration: 0.2,
//                 ease: "easeOut"
//             }
//         }
//     };

//     const pillContainerVariants = {
//         hidden: { opacity: 0, scale: 0.9 },
//         visible: {
//             opacity: 1,
//             scale: 1,
//             transition: {
//                 duration: 0.3,
//                 staggerChildren: 0.1
//             }
//         }
//     };

//     const pillVariants = {
//         inactive: {
//             scale: 1,
//             backgroundColor: "transparent",
//             color: "#64748b",
//             transition: { duration: 0.3, ease: "easeInOut" }
//         },
//         active: {
//             scale: 1.05,
//             backgroundColor: "#252e9d",
//             color: "#ffffff",
//             transition: { duration: 0.3, ease: "easeInOut" }
//         },
//         hover: {
//             scale: 1.08,
//             backgroundColor: "transparent",
//             color: "black",
//             transition: { duration: 0.2, ease: "easeOut" }
//         }
//     };

//     const swapVariants = {
//         left: { x: 0 },
//         right: { x: 120 },
//         transition: { duration: 0.4, ease: "easeInOut" }
//     };

//     const fetchPlanData = async () => {
//         try {
//             const [planRangeRes, planTypeRes, planPeriodRes, priceRes] = await Promise.all([
//                 fetch(`${API_URL}/public/plan-range/all`),
//                 fetch(`${API_URL}/public/plan-type/all`),
//                 fetch(`${API_URL}/public/plan-period/all`),
//                 fetch(`${API_URL}/public/plan/getAll`),
//             ]);

//             if (!planRangeRes.ok || !planTypeRes.ok || !planPeriodRes.ok || !priceRes.ok) {
//                 throw new Error("Failed to fetch data");
//             }

//             const planRangesData = await planRangeRes.json();
//             const planTypesData = await planTypeRes.json();
//             const planPeriodsData = await planPeriodRes.json();
//             const pricesData = await priceRes.json();

//             setPlanRanges(planRangesData || []);
//             setPlanTypes(planTypesData || []);
//             setPlanPeriods(planPeriodsData || []);
//             setPrices(pricesData || []);
//             setLoading(false);
//         } catch (error) {
//             console.error("Error fetching plan data:", error);
//             setError(error.message);
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchPlanData();
//     }, []);

//     const fetchDataAndDisplayLog = async (planRangeId, planPeriodId) => {
//         try {
//             setData([]); // Reset data before fetching
//             const response = await axios.get(
//                 `${API_URL}/public/plan/findByRangeAndPeriod/${planRangeId}/${planPeriodId}`
//             );

//             if (response.data && Array.isArray(response.data)) {
//                 setData(response.data);
//                 setPlanIds(response.data.map((item) => item.planId || item.id)); // Fallback for different ID fields
//             } else {
//                 setData([]);
//                 setPlanIds([]);
//             }
//         } catch (error) {
//             console.error("Error fetching data:", error);
//             setData([]);
//             setPlanIds([]);
//         }
//     };

//     useEffect(() => {
//         if (planRangeId && planPeriodId) {
//             fetchDataAndDisplayLog(planRangeId, planPeriodId);
//         }
//     }, [planRangeId, planPeriodId]);

//     useEffect(() => {
//         const fetchPlanDetails = async () => {
//             try {
//                 if (planIds.length === 0) {
//                     setPlanDetails({});
//                     return;
//                 }

//                 const detailsMap = {};
//                 const fetchPromises = planIds.map(async (id) => {
//                     try {
//                         const response = await fetch(`${API_URL}/public/plandetail/getPlanDetailByPlanId/${id}`);
//                         if (response.ok) {
//                             const data = await response.json();
//                             detailsMap[id] = Array.isArray(data) ? data : [];
//                         } else {
//                             detailsMap[id] = [];
//                         }
//                     } catch (error) {
//                         console.error(`Error fetching plan details for plan ID ${id}:`, error);
//                         detailsMap[id] = [];
//                     }
//                 });

//                 await Promise.all(fetchPromises);
//                 setPlanDetails(detailsMap);
//             } catch (error) {
//                 console.error("Error fetching plan details:", error);
//                 setPlanDetails({});
//             }
//         };

//         fetchPlanDetails();
//     }, [planIds]);

//     const handleChoosePlan = async (planId) => {
//         setIsModalVisible(true);
//         setPlanId(planId);
//     };

//     const handleProcessBarClick = (index) => {
//         if (planRanges[index]) {
//             setVisibleSliderIndex(index);
//             const selectedRange = planRanges[index];
//             setPlanRangeId(selectedRange.id);
//         }
//     };

//     const handlePeriodChange = (isMonthlySelected) => {
//         setIsMonthly(isMonthlySelected);
//         const selectedPeriod = planPeriods.find((period) =>
//             isMonthlySelected ? period.planPeriod === "Monthly" : period.planPeriod === "Yearly"
//         );
//         if (selectedPeriod) {
//             setPlanPeriodId(selectedPeriod.id);
//         }
//     };

//     if (loading) {
//         return (
//             <div className="bg-[#ebf4ff] py-20 min-h-screen" id="hoa-plan">
//                 <div className="w-[90%] max-w-6xl mx-auto flex flex-col gap-12">
//                     <div className="text-center py-15 px-5 text-[#252e9d] text-lg">
//                         <motion.div
//                             animate={{ rotate: 360 }}
//                             transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
//                             className="w-8 h-8 border-4 border-[#252e9d] border-t-transparent rounded-full mx-auto mb-4"
//                         />
//                         <p>Loading plans...</p>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="bg-[#ebf4ff] py-20 min-h-screen" id="hoa-plan">
//                 <div className="w-[90%] max-w-6xl mx-auto flex flex-col gap-12">
//                     <div className="text-center py-15 px-5 text-[#252e9d] text-lg">
//                         <p>Error loading plans: {error}</p>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="bg-[#ebf4ff] py-20 min-h-screen" id="hoa-plan">
//             <motion.div
//                 className="w-[90%] max-w-7xl mx-auto flex flex-col gap-4 md:gap-12"
//                 variants={containerVariants}
//                 initial="hidden"
//                 animate="visible"
//             >
//                 {/* Header Section */}
//                 <motion.div
//                     className="flex flex-col items-center gap-8 text-center"
//                     variants={itemVariants}
//                 >
//                     <motion.h2
//                         className="text-[#252e9d] text-2xl md:text-4xl font-bold leading-tight m-0"
//                         initial={{ opacity: 0, y: -30 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.6, delay: 0.2 }}
//                     >
//                         Choose your plan
//                     </motion.h2>
//                     <motion.div
//                         className="flex justify-center items-center gap-10 flex-wrap sm:flex-col sm:gap-4 md:flex-row md:gap-6"
//                         variants={containerVariants}
//                     >
//                         {[
//                             { text: "14 days free trial" },
//                             { text: "No contract" },
//                             { text: "No hidden fees" }
//                         ].map((item, index) => (
//                             <motion.div
//                                 key={index}
//                                 className="flex gap-3 items-center py-3 px-6 bg-[#fefeff] rounded-full shadow-lg backdrop-blur-sm border border-white/20"
//                                 variants={itemVariants}
//                                 whileHover={{
//                                     scale: 1.05,
//                                     boxShadow: "0 10px 25px rgba(37, 46, 157, 0.1)"
//                                 }}
//                                 transition={{ duration: 0.2 }}
//                             >
//                                 <FaCheckCircle className="text-lg text-emerald-500" />
//                                 <p className="text-base text-[#252e9d] m-0 font-semibold">{item.text}</p>
//                             </motion.div>
//                         ))}
//                     </motion.div>

//                 </motion.div>

//                 {/* Plan Selection Section */}
//                 <motion.div
//                     // className="flex flex-col gap-10"
//                     className="flex flex-col gap-10"
//                     variants={itemVariants}
//                 >
//                     {/* Plan Range Buttons */}
//                     {/* <motion.div
//                         className="flex justify-center items-center"
//                         variants={pillContainerVariants}
//                     >
//                         <div className="flex bg-transparent justify-center md:justify-start md:bg-[#fefeff] rounded-full p-2 gap-2 shadow-none md:shadow-lg border border-white/30 flex-wrap">
//                             {planRanges.map((range, index) => (
//                                 <motion.button
//                                     key={range.id || index}
//                                     className={`px-6 py-3 text-sm font-semibold rounded-full transition-all duration-300 ease-out outline-none min-w-[100px] border-2 shadow-xl md:shadow-none ${visibleSliderIndex === index
//                                         ? "bg-[#252e9d] text-white shadow-lg border-[#252e9d]"
//                                         : "bg-white md:bg-transparent text-[#252e9d] hover:text-[#252e9d]  hover:border-[#252e9d] border border-transparent"
//                                         }`}
//                                     onClick={() => handleProcessBarClick(index)}
//                                     variants={pillVariants}
//                                     animate={visibleSliderIndex === index ? "active" : "inactive"}
//                                     whileHover="hover"
//                                     whileTap={{ scale: 0.95 }}
//                                     layout
//                                 >
//                                     {range.planRange}
//                                 </motion.button>
//                             ))}
//                         </div>
//                     </motion.div> */}

//                     {/* Monthly/Yearly Toggle with Swapping Animation */}
//                     <motion.div
//                         className="flex justify-center items-center"
//                         variants={pillContainerVariants}
//                     >
//                         <div className="relative flex bg-[#fefeff] rounded-full p-2 shadow-lg border border-white/30 w-[240px] h-[60px]">
//                             {/* Active pill background that moves */}
//                             <motion.div
//                                 className="absolute top-2 w-[100px] h-[44px] bg-[#252e9d] rounded-full shadow-lg"
//                                 animate={{
//                                     x: isMonthly ? 0 : 115
//                                 }}
//                                 transition={{ duration: 0.4, ease: "easeInOut" }}
//                             />

//                             {/* Monthly Button */}
//                             <motion.button
//                                 className="relative z-10 px-6 py-3 pl-2.5 text-sm font-semibold rounded-full transition-all duration-300 ease-out outline-none w-[116px]"
//                                 onClick={() => handlePeriodChange(true)}
//                                 animate={{
//                                     color: isMonthly ? "#ffffff" : "#252e9d"
//                                 }}
//                                 whileHover={{ scale: 1.05 }}
//                                 whileTap={{ scale: 0.95 }}
//                             >
//                                 Monthly
//                             </motion.button>

//                             {/* Yearly Button */}
//                             <motion.button
//                                 className="relative z-10 px-6 py-3 text-sm font-semibold rounded-full transition-all duration-300 ease-out outline-none w-[116px]"
//                                 onClick={() => handlePeriodChange(false)}
//                                 animate={{
//                                     color: !isMonthly ? "#ffffff" : "#252e9d"
//                                 }}
//                                 whileHover={{ scale: 1.05 }}
//                                 whileTap={{ scale: 0.95 }}
//                             >
//                                 Yearly
//                             </motion.button>
//                         </div>
//                     </motion.div>

//                     {/* Plans Slider */}
//                     <motion.div
//                         className="slider-container md:overflow-visible overflow-hidden"
//                         initial={{ opacity: 0, y: 30 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.6, delay: 0.3 }}
//                     >
//                         <style jsx>{`
//                             .slider-container .slick-list {
//                                 padding: 0 20px;
//                                 overflow: visible;
//                             }
//                             .slider-container .slick-track {
//                                 display: flex;
//                                 align-items: stretch;
//                             }
//                             .slider-container .slick-slide {
//                                 padding: 0 12px;
//                                 height: auto;
//                             }
//                             .slider-container .slick-slide > div {
//                                 height: 100%;
//                             }
//                             .slider-container .slick-prev,
//                             .slider-container .slick-next {
//                                 z-index: 2;
//                                 width: 50px;
//                                 height: 50px;
//                                 background: rgba(255, 255, 255, 0.95);
//                                 border-radius: 50%;
//                                 box-shadow: 0 8px 25px rgba(37, 46, 157, 0.15);
//                                 backdrop-filter: blur(10px);
//                                 border: 2px solid rgba(37, 46, 157, 0.1);
//                             }
//                             .slider-container .slick-prev:before,
//                             .slider-container .slick-next:before {
//                                 font-size: 20px;
//                                 color: #252e9d;
//                                 opacity: 1;
//                             }
//                             .slider-container .slick-prev:hover,
//                             .slider-container .slick-next:hover {
//                                 background: #252e9d;
//                                 transform: scale(1.1);
//                             }
//                             .slider-container .slick-prev:hover:before,
//                             .slider-container .slick-next:hover:before {
//                                 color: #FFFFFF;
//                             }
//                             .slider-container .slick-prev {
//                                 left: -25px;
//                             }
//                             .slider-container .slick-next {
//                                 right: -25px;
//                             }
//                             @media screen and (max-width: 480px) {
//                                 .slider-container .slick-list {
//                                 padding: 0 10px;
//                                 }
//                                 .slider-container .slick-prev,
//                                 .slider-container .slick-next {
//                                 display: none !important;
//                                 }
//                             }
//                             @media screen and (min-width: 481px) and (max-width: 768px) {
//                                 .slider-container .slick-prev,
//                                 .slider-container .slick-next {
//                                 display: block !important;
//                                 }
//                             }
//                             @media screen and (min-width: 769px) and (max-width: 1024px) {
//                                 .slider-container .slick-prev,
//                                 .slider-container .slick-next {
//                                 display: block !important;
//                                 }
//                             }
//                             @media screen and (min-width: 1025px) {
//                                 .slider-container .slick-prev,
//                                 .slider-container .slick-next {
//                                 display: none !important;
//                                 }
//                             }
//                             `}</style>
//                         {data && data.length > 0 ? (
//                             <Slider {...slickSettings}>
//                                 {data.map((item, index) => (
//                                     <div key={item.planId || item.id || index} className="h-full">
//                                         <motion.div
//                                             className="bg-[#fefeff] rounded-3xl p-8 h-full flex flex-col relative transition-all duration-300 ease-out border-2 border-white/50 backdrop-blur-xl shadow-lg sm:p-6 md:p-7 overflow-hidden"
//                                             variants={cardVariants}
//                                             initial="hidden"
//                                             animate="visible"
//                                             whileHover="hover"
//                                             transition={{ delay: index * 0.1 }}
//                                         >
//                                             {/* Popular badge for middle card */}
//                                             {/* {index === Math.floor(data.length / 2) && (
//                                                 <motion.div
//                                                     className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-[#252e9d] to-[#60a5fa] text-white px-6 py-2 rounded-full text-sm font-semibold shadow-lg"
//                                                     initial={{ opacity: 0, y: -10 }}
//                                                     animate={{ opacity: 1, y: 0 }}
//                                                     transition={{ delay: 0.5 }}
//                                                 >
//                                                     Most Popular
//                                                 </motion.div>
//                                             )} */}

//                                             <div className="text-center mb-8 sm:mb-6">
//                                                 <motion.h3
//                                                     className="text-2xl font-bold text-[#252e9d] m-0 mb-4 sm:text-xl"
//                                                     initial={{ opacity: 0 }}
//                                                     animate={{ opacity: 1 }}
//                                                     transition={{ delay: 0.3 }}
//                                                 >
//                                                     {item.planType?.planType || 'Standard Plan'}
//                                                 </motion.h3>
//                                                 <motion.div
//                                                     className="flex items-baseline justify-center gap-1"
//                                                     initial={{ scale: 0.8, opacity: 0 }}
//                                                     animate={{ scale: 1, opacity: 1 }}
//                                                     transition={{ delay: 0.4, duration: 0.3 }}
//                                                 >
//                                                     <span className="text-2xl font-semibold text-[#252e9d] sm:text-xl">$</span>
//                                                     <span className="text-5xl font-extrabold text-[#252e9d] leading-none sm:text-4xl">
//                                                         {item.price || '0'}
//                                                     </span>
//                                                     <span className="text-lg font-medium text-slate-500 sm:text-base">
//                                                         /{isMonthly ? 'month' : 'year'}
//                                                     </span>
//                                                 </motion.div>
//                                             </div>

//                                             <div className="flex-1 flex flex-col gap-4 mb-8 sm:mb-6 sm:gap-3.5">
//                                                 {planDetails[item.planId || item.id] && Array.isArray(planDetails[item.planId || item.id]) ?
//                                                     planDetails[item.planId || item.id].map((detail, detailIndex) => (
//                                                         <motion.div
//                                                             className="flex items-start gap-3"
//                                                             key={detailIndex}
//                                                             initial={{ opacity: 0, x: -10 }}
//                                                             animate={{ opacity: 1, x: 0 }}
//                                                             transition={{ delay: 0.5 + (detailIndex * 0.1) }}
//                                                         >
//                                                             <FaCheck className="text-base text-emerald-500 mt-0.5 flex-shrink-0" />
//                                                             <span className="text-base text-slate-600 leading-relaxed font-medium sm:text-sm">
//                                                                 {detail.name || 'Feature'}
//                                                             </span>
//                                                         </motion.div>
//                                                     )) : (
//                                                         <motion.div
//                                                             className="flex items-start gap-3"
//                                                             initial={{ opacity: 0, x: -10 }}
//                                                             animate={{ opacity: 1, x: 0 }}
//                                                             transition={{ delay: 0.5 }}
//                                                         >
//                                                             <FaCheck className="text-base text-emerald-500 mt-0.5 flex-shrink-0" />
//                                                             <span className="text-base text-slate-600 leading-relaxed font-medium sm:text-sm">
//                                                                 Standard features included
//                                                             </span>
//                                                         </motion.div>
//                                                     )
//                                                 }
//                                             </div>

//                                             <motion.div
//                                                 initial={{ opacity: 0, y: 20 }}
//                                                 animate={{ opacity: 1, y: 0 }}
//                                                 transition={{ delay: 0.6 }}
//                                             >
//                                                 <motion.button
//                                                     className="w-full bg-[#252e9d] text-white border-2 border-[#252e9d] hover:border-transparent rounded-2xl py-4 px-6 text-base font-semibold cursor-pointer transition-all duration-300 ease-out outline-none relative overflow-hidden group"
//                                                     onClick={() => handleChoosePlan(item.planId || item.id)}
//                                                     whileHover={{
//                                                         scale: 1.02,
//                                                         boxShadow: "0 10px 25px rgba(37, 46, 157, 0.3)"
//                                                     }}
//                                                     whileTap={{ scale: 0.98 }}
//                                                 >
//                                                     <span className="relative z-10">Choose Plan</span>
//                                                 </motion.button>
//                                             </motion.div>
//                                         </motion.div>
//                                     </div>
//                                 ))}
//                             </Slider>
//                         ) : (
//                             <motion.div
//                                 className="text-center py-15 px-5 text-slate-500 text-base"
//                                 initial={{ opacity: 0 }}
//                                 animate={{ opacity: 1 }}
//                                 transition={{ delay: 0.3 }}
//                             >
//                                 <p>No plans available for the selected range and period.</p>
//                             </motion.div>
//                         )}
//                     </motion.div>
//                 </motion.div>

//                 {/* Footer */}
//                 <motion.div
//                     className="text-center"
//                     variants={itemVariants}
//                 >
//                     <p className="text-slate-500 text-base leading-relaxed m-0">
//                         We can customize your plan based on your requirement.{" "}
//                         <span>
//                             <ScrollLink
//                                 to="hoa-contact"
//                                 smooth={true}
//                                 duration={500}
//                                 className="text-[#252e9d] no-underline font-semibold relative hover:underline cursor-pointer"
//                             >
//                                 Reach out to us.
//                             </ScrollLink>
//                         </span>
//                         <div>
//                             No credit card required. Cancel anytime.
//                         </div>
//                     </p>

//                 </motion.div>
//             </motion.div>

//             {/* Modal */}
//             {/*<AnimatePresence>*/}
//             {/*    {isModalVisible && (*/}
//             {/*        <motion.div*/}
//             {/*            className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[9999] backdrop-blur-lg"*/}
//             {/*            initial={{ opacity: 0 }}*/}
//             {/*            animate={{ opacity: 1 }}*/}
//             {/*            exit={{ opacity: 0 }}*/}
//             {/*            transition={{ duration: 0.3 }}*/}
//             {/*        >*/}
//             {/*            <motion.div*/}
//             {/*                className="absolute bg-black/50 top-0 bottom-0 left-0 right-0 flex justify-center items-center"*/}
//             {/*                initial={{ opacity: 0 }}*/}
//             {/*                animate={{ opacity: 1 }}*/}
//             {/*                exit={{ opacity: 0 }}*/}
//             {/*            >*/}
//             {/*                <motion.div*/}
//             {/*                    className="bg-[#252e9d] p-6 rounded-3xl shadow-xl w-[90%] max-w-3xl max-h-[90vh] overflow-hidden sm:w-[95%] sm:p-5"*/}
//             {/*                    initial={{ scale: 0.8, opacity: 0, y: 50 }}*/}
//             {/*                    animate={{ scale: 1, opacity: 1, y: 0 }}*/}
//             {/*                    exit={{ scale: 0.8, opacity: 0, y: 50 }}*/}
//             {/*                    transition={{ duration: 0.3, ease: "easeOut" }}*/}
//             {/*                >*/}
//             {/*                    <div className="flex justify-end mb-4">*/}
//             {/*                        <motion.button*/}
//             {/*                            onClick={() => setIsModalVisible(false)}*/}
//             {/*                            className="bg-white/10 border-none rounded-xl p-3 cursor-pointer transition-all duration-300 hover:bg-white/20"*/}
//             {/*                            whileHover={{ scale: 1.1, rotate: 90 }}*/}
//             {/*                            whileTap={{ scale: 0.9 }}*/}
//             {/*                        >*/}
//             {/*                            <RxCross1 className="text-white text-xl" />*/}
//             {/*                        </motion.button>*/}
//             {/*                    </div>*/}
//             {/*                    <div className="h-auto max-h-[calc(90vh-100px)] overflow-y-auto">*/}
//             {/*                        <HoaChoosePlan*/}
//             {/*                            planIds={planId}*/}
//             {/*                            closeModal={setIsModalVisible}*/}
//             {/*                        />*/}
//             {/*                    </div>*/}
//             {/*                </motion.div>*/}
//             {/*            </motion.div>*/}
//             {/*        </motion.div>*/}
//             {/*    )}*/}
//             {/*</AnimatePresence>*/}
//             {/* Improved Modal */}
//             <AnimatePresence>
//                 {isModalVisible && (
//                     <motion.div
//                         className="fixed left-0 w-full h-full flex justify-center items-center z-[9999] top-[0px] md:top-[40px] backdrop-blur-lg "
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         exit={{ opacity: 0 }}
//                         transition={{ duration: 0.3 }}
//                     >
//                         <motion.div
//                             className="absolute bg-black/50 top-0 bottom-0 left-0 right-0 flex justify-center items-center p-4"
//                             initial={{ opacity: 0 }}
//                             animate={{ opacity: 1 }}
//                             exit={{ opacity: 0 }}
//                         >
//                             <motion.div
//                                 className="bg-gradient-to-br from-blue-800 to-blue-900 rounded-3xl shadow-2xl w-[95%] max-w-[1200px] max-h-[87vh] overflow-hidden hover:overflow-y-auto relative custom-scrollbar"
//                                 initial={{ scale: 0.8, opacity: 0, y: 50 }}
//                                 animate={{ scale: 1, opacity: 1, y: 0 }}
//                                 exit={{ scale: 0.8, opacity: 0, y: 50 }}
//                                 transition={{ duration: 0.3, ease: "easeOut" }}
//                             >
//                                 {/* Close Button - Positioned absolutely */}
//                                 <motion.button
//                                     onClick={() => setIsModalVisible(false)}
//                                     className="absolute top-4 right-4 z-50 bg-white/10 border-none rounded-xl p-3 cursor-pointer transition-all duration-300 hover:bg-white/20"
//                                     whileHover={{ scale: 1.1, rotate: 90 }}
//                                     whileTap={{ scale: 0.9 }}
//                                 >
//                                     <RxCross1 className="text-white text-xl" />
//                                 </motion.button>

//                                 {/* Content without scrolling */}
//                                 <div className="w-full h-full overflow-auto">
//                                     <HoaChoosePlan
//                                         planIds={planId}
//                                         closeModal={setIsModalVisible}
//                                     />
//                                 </div>
//                             </motion.div>
//                         </motion.div>
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </div>
//     );
// };

// export default HoaPlan;

import React, { useState, useEffect } from "react";
import { FaDollarSign, FaCheck, FaCheckCircle, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../apiConfig";
import HoaChoosePlan from "../HoaChoosePlan/HoaChoosePlan";
import { RxCross1 } from "react-icons/rx";
import axios from "axios";

const HoaPlan = () => {
    const [isMonthly, setIsMonthly] = useState(true); // Default to monthly
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [visibleSliderIndex, setVisibleSliderIndex] = useState(0);
    const [planId, setPlanId] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const dispatch = useDispatch();

    // Hardcoded pricing data that matches your original structure
    const data = [
        {
            planId: 1,
            id: 1,
            price: isMonthly ? 24 : 276,
            planType: {
                planType: "Basic"
            }
        },
        {
            planId: 2,
            id: 2,
            price: isMonthly ? 37 : 432,
            planType: {
                planType: "Comprehensive"
            }
        }
    ];

    // Hardcoded plan details with included/excluded features
    const planDetails = {
        1: [ // Basic plan features
            { name: "Community website with CMS", included: true },
            { name: "Data storage", included: true },
            { name: "9/6 Email support", included: true },
            { name: "Payment Integration", included: true },
            { name: "Basic Accounting", included: true },
            { name: "Access to archived data", included: true },
            { name: "Mailing cost", included: false },
            { name: "Automated Vendor Management", included: false },
            { name: "Running Semi-Annual HOA meetings", included: false }
        ],
        2: [ // Comprehensive plan features
            { name: "Everything in Basic Plan", included: true },
            { name: "Data Storage cost", included: true },
            { name: "9/6 phone support", included: true },
            { name: "Budget Planning", included: true },
            { name: "Automated vendor management", included: true },
            { name: "Running Semi-Annual HOA meeting", included: true },
            { name: "50 mails per month", included: true }
        ]
    };

    const slickSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.4 }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, scale: 0.9, y: 50 },
        visible: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        },
        hover: {
            y: -8,
            scale: 1.02,
            transition: {
                duration: 0.2,
                ease: "easeOut"
            }
        }
    };

    const pillContainerVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.3,
                staggerChildren: 0.1
            }
        }
    };

    const handleChoosePlan = async (planId) => {
        setIsModalVisible(true);
        setPlanId(planId);
    };

    const handlePeriodChange = (isMonthlySelected) => {
        setIsMonthly(isMonthlySelected);
    };

    return (
        <div className="bg-[#ebf4ff] py-20 min-h-screen" id="hoa-plan">
            <motion.div
                className="w-[90%] max-w-7xl mx-auto flex flex-col gap-4 md:gap-12"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {/* Header Section */}
                <motion.div
                    className="flex flex-col items-center gap-8 text-center"
                    variants={itemVariants}
                >
                    <motion.h2
                        className="text-[#252e9d] text-2xl md:text-4xl font-bold leading-tight m-0"
                        initial={{ opacity: 0, y: -30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        Choose your plan
                    </motion.h2>
                    <motion.div
                        className="flex justify-center items-center gap-10 flex-wrap sm:flex-col sm:gap-4 md:flex-row md:gap-6"
                        variants={containerVariants}
                    >
                        {[
                            { text: "14 days free trial" },
                            { text: "No contract" },
                            { text: "No hidden fees" }
                        ].map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex gap-3 items-center py-3 px-6 bg-[#fefeff] rounded-full shadow-lg backdrop-blur-sm border border-white/20"
                                variants={itemVariants}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0 10px 25px rgba(37, 46, 157, 0.1)"
                                }}
                                transition={{ duration: 0.2 }}
                            >
                                <FaCheckCircle className="text-lg text-emerald-500" />
                                <p className="text-base text-[#252e9d] m-0 font-semibold">{item.text}</p>
                            </motion.div>
                        ))}
                    </motion.div>

                </motion.div>

                {/* Plan Selection Section */}
                <motion.div
                    className="flex flex-col gap-10"
                    variants={itemVariants}
                >
                    {/* Monthly/Yearly Toggle with Swapping Animation */}
                    <motion.div
                        className="flex justify-center items-center"
                        variants={pillContainerVariants}
                    >
                        <div className="relative flex bg-[#fefeff] rounded-full p-2 shadow-lg border border-white/30 w-[240px] h-[60px]">
                            {/* Active pill background that moves */}
                            <motion.div
                                className="absolute top-2 w-[100px] h-[44px] bg-[#252e9d] rounded-full shadow-lg"
                                animate={{
                                    x: isMonthly ? 0 : 115
                                }}
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                            />

                            {/* Monthly Button */}
                            <motion.button
                                className="relative z-10 px-6 py-3 pl-2.5 text-sm font-semibold rounded-full transition-all duration-300 ease-out outline-none w-[116px]"
                                onClick={() => handlePeriodChange(true)}
                                animate={{
                                    color: isMonthly ? "#ffffff" : "#252e9d"
                                }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                Monthly
                            </motion.button>

                            {/* Yearly Button */}
                            <motion.button
                                className="relative z-10 px-6 py-3 text-sm font-semibold rounded-full transition-all duration-300 ease-out outline-none w-[116px]"
                                onClick={() => handlePeriodChange(false)}
                                animate={{
                                    color: !isMonthly ? "#ffffff" : "#252e9d"
                                }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                Yearly
                            </motion.button>
                        </div>
                    </motion.div>

                    {/* Plans Slider */}
                    <motion.div
                        className="slider-container md:overflow-visible overflow-hidden"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                    >
                        <style jsx>{`
                            .slider-container .slick-list {
                                padding: 0 20px;
                                overflow: visible;
                            }
                            .slider-container .slick-track {
                                display: flex;
                                align-items: stretch;
                            }
                            .slider-container .slick-slide {
                                padding: 0 12px;
                                height: auto;
                            }
                            .slider-container .slick-slide > div {
                                height: 100%;
                            }
                            .slider-container .slick-prev,
                            .slider-container .slick-next {
                                z-index: 2;
                                width: 50px;
                                height: 50px;
                                background: rgba(255, 255, 255, 0.95);
                                border-radius: 50%;
                                box-shadow: 0 8px 25px rgba(37, 46, 157, 0.15);
                                backdrop-filter: blur(10px);
                                border: 2px solid rgba(37, 46, 157, 0.1);
                            }
                            .slider-container .slick-prev:before,
                            .slider-container .slick-next:before {
                                font-size: 20px;
                                color: #252e9d;
                                opacity: 1;
                            }
                            .slider-container .slick-prev:hover,
                            .slider-container .slick-next:hover {
                                background: #252e9d;
                                transform: scale(1.1);
                            }
                            .slider-container .slick-prev:hover:before,
                            .slider-container .slick-next:hover:before {
                                color: #FFFFFF;
                            }
                            .slider-container .slick-prev {
                                left: -25px;
                            }
                            .slider-container .slick-next {
                                right: -25px;
                            }
                            @media screen and (max-width: 480px) {
                                .slider-container .slick-list {
                                padding: 0 10px;
                                }
                                .slider-container .slick-prev,
                                .slider-container .slick-next {
                                display: none !important;
                                }
                            }
                            @media screen and (min-width: 481px) and (max-width: 768px) {
                                .slider-container .slick-prev,
                                .slider-container .slick-next {
                                display: block !important;
                                }
                            }
                            @media screen and (min-width: 769px) and (max-width: 1024px) {
                                .slider-container .slick-prev,
                                .slider-container .slick-next {
                                display: block !important;
                                }
                            }
                            @media screen and (min-width: 1025px) {
                                .slider-container .slick-prev,
                                .slider-container .slick-next {
                                display: none !important;
                                }
                            }
                            `}</style>
                        {data && data.length > 0 ? (
                            <Slider {...slickSettings}>
                                {data.map((item, index) => (
                                    <div key={item.planId || item.id || index} className="h-full">
                                        <motion.div
                                            className="bg-[#fefeff] rounded-3xl p-8 h-full flex flex-col relative transition-all duration-300 ease-out border-2 border-white/50 backdrop-blur-xl shadow-lg sm:p-6 md:p-7 overflow-hidden"
                                            variants={cardVariants}
                                            initial="hidden"
                                            animate="visible"
                                            whileHover="hover"
                                            transition={{ delay: index * 0.1 }}
                                        >
                                            <div className="text-center mb-8 sm:mb-6">
                                                <motion.h3
                                                    className="text-2xl font-bold text-[#252e9d] m-0 mb-4 sm:text-xl"
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1 }}
                                                    transition={{ delay: 0.3 }}
                                                >
                                                    {item.planType?.planType || 'Standard Plan'}
                                                </motion.h3>
                                                <motion.div
                                                    className="flex items-baseline justify-center gap-1"
                                                    initial={{ scale: 0.8, opacity: 0 }}
                                                    animate={{ scale: 1, opacity: 1 }}
                                                    transition={{ delay: 0.4, duration: 0.3 }}
                                                >
                                                    <span className="text-2xl font-semibold text-[#252e9d] sm:text-xl">$</span>
                                                    <span className="text-5xl font-extrabold text-[#252e9d] leading-none sm:text-4xl">
                                                        {item.price || '0'}
                                                    </span>
                                                    <span className="text-lg font-medium text-slate-500 sm:text-base">
                                                        /{isMonthly ? 'unit/month' : 'unit/year'}
                                                    </span>
                                                </motion.div>
                                            </div>

                                            <div className="flex-1 flex flex-col gap-4 mb-8 sm:mb-6 sm:gap-3.5">
                                                {planDetails[item.planId || item.id] && Array.isArray(planDetails[item.planId || item.id]) ?
                                                    planDetails[item.planId || item.id].map((detail, detailIndex) => (
                                                        <motion.div
                                                            className="flex items-start gap-3"
                                                            key={detailIndex}
                                                            initial={{ opacity: 0, x: -10 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            transition={{ delay: 0.5 + (detailIndex * 0.1) }}
                                                        >
                                                            {detail.included ? (
                                                                <FaCheck className="text-base text-emerald-500 mt-0.5 flex-shrink-0" />
                                                            ) : (
                                                                <FaTimes className="text-base text-red-500 mt-0.5 flex-shrink-0" />
                                                            )}
                                                            <span className={`text-base leading-relaxed font-medium sm:text-sm ${detail.included ? 'text-slate-600' : 'text-red-500'
                                                                }`}>
                                                                {detail.name || 'Feature'}
                                                            </span>
                                                        </motion.div>
                                                    )) : (
                                                        <motion.div
                                                            className="flex items-start gap-3"
                                                            initial={{ opacity: 0, x: -10 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            transition={{ delay: 0.5 }}
                                                        >
                                                            <FaCheck className="text-base text-emerald-500 mt-0.5 flex-shrink-0" />
                                                            <span className="text-base text-slate-600 leading-relaxed font-medium sm:text-sm">
                                                                Standard features included
                                                            </span>
                                                        </motion.div>
                                                    )
                                                }
                                            </div>

                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ delay: 0.6 }}
                                            >
                                                <motion.button
                                                    className="w-full bg-[#252e9d] text-white border-2 border-[#252e9d] hover:border-transparent rounded-2xl py-4 px-6 text-base font-semibold cursor-pointer transition-all duration-300 ease-out outline-none relative overflow-hidden group"
                                                    onClick={() => handleChoosePlan(item.planId || item.id)}
                                                    whileHover={{
                                                        scale: 1.02,
                                                        boxShadow: "0 10px 25px rgba(37, 46, 157, 0.3)"
                                                    }}
                                                    whileTap={{ scale: 0.98 }}
                                                >
                                                    <span className="relative z-10">Choose Plan</span>
                                                </motion.button>
                                            </motion.div>
                                        </motion.div>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <motion.div
                                className="text-center py-15 px-5 text-slate-500 text-base"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.3 }}
                            >
                                <p>No plans available for the selected range and period.</p>
                            </motion.div>
                        )}
                    </motion.div>
                </motion.div>

                {/* Footer */}
                <motion.div
                    className="text-center"
                    variants={itemVariants}
                >
                    <p className="text-slate-500 text-base leading-relaxed m-0">
                        We can customize your plan based on your requirement.{" "}
                        <span>
                            <ScrollLink
                                to="#hoa-contact"
                                smooth={true}
                                duration={500}
                                className="text-[#252e9d] no-underline font-semibold relative hover:underline cursor-pointer"
                            >
                                Reach out to us.
                            </ScrollLink>
                        </span>
                        <div>
                            No credit card required. Cancel anytime.
                        </div>
                    </p>

                </motion.div>
            </motion.div>

            {/* Modal */}
            <AnimatePresence>
                {isModalVisible && (
                    <motion.div
                        className="fixed left-0 w-full h-full flex justify-center items-center z-[9999] top-[0px] md:top-[40px] backdrop-blur-lg "
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            className="absolute bg-black/50 top-0 bottom-0 left-0 right-0 flex justify-center items-center p-4"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <motion.div
                                className="bg-gradient-to-br from-blue-800 to-blue-900 rounded-3xl shadow-2xl w-[95%] max-w-[1200px] max-h-[87vh] overflow-hidden hover:overflow-y-auto relative custom-scrollbar"
                                initial={{ scale: 0.8, opacity: 0, y: 50 }}
                                animate={{ scale: 1, opacity: 1, y: 0 }}
                                exit={{ scale: 0.8, opacity: 0, y: 50 }}
                                transition={{ duration: 0.3, ease: "easeOut" }}
                            >
                                {/* Close Button - Positioned absolutely */}
                                <motion.button
                                    onClick={() => setIsModalVisible(false)}
                                    className="absolute top-4 right-4 z-50 bg-white/10 border-none rounded-xl p-3 cursor-pointer transition-all duration-300 hover:bg-white/20"
                                    whileHover={{ scale: 1.1, rotate: 90 }}
                                    whileTap={{ scale: 0.9 }}
                                >
                                    <RxCross1 className="text-white text-xl" />
                                </motion.button>

                                {/* Content without scrolling */}
                                <div className="w-full h-full overflow-auto">
                                    <HoaChoosePlan
                                        planIds={planId}
                                        closeModal={setIsModalVisible}
                                    />
                                </div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default HoaPlan;